import moment from 'moment';

export function getTimelineDays(phases, allowedStatuses, noAdditionalDays) {
  let allStartDates = [];
  let allEndDates = [];

  // Flatten all work packages and collect dates
  const workPackages = phases.flatMap((phase) => phase.workPackages || []);

  workPackages.forEach((wp) => {
    if (!allowedStatuses.includes(wp.status)) return; // skip wps with a status that is not allowed
    if (wp.startDate) allStartDates.push(moment(wp.startDate));
    if (wp.endDate) allEndDates.push(moment(wp.endDate));
  });

  const days = [];

  if (
    noAdditionalDays &&
    allStartDates.length === 0 &&
    allEndDates.length === 0
  ) {
    return days;
  }

  // If there are no start or end dates, return 30 additional days from today
  if (
    !noAdditionalDays &&
    allStartDates.length === 0 &&
    allEndDates.length === 0
  ) {
    const additionalDays = 30;
    const startDate = moment().subtract(3, 'days').startOf('day');
    for (let i = 0; i < additionalDays; i++) {
      const lastDay =
        days.length > 0
          ? days[days.length - 1].date.clone().add(1, 'day')
          : startDate;
      days.push({
        date: lastDay,
        hasWPStart: false,
        hasWPEnd: false,
        workPackagesStarting: [],
        workPackagesEnding: [],
      });
    }

    return days;
  }

  const minDate = moment.min([...allStartDates, ...allEndDates]);
  const maxDate = moment.max([...allStartDates, ...allEndDates]);

  let current = minDate.clone();

  while (
    allStartDates.length !== 0 &&
    allEndDates.length !== 0 &&
    current.isSameOrBefore(maxDate, 'day')
  ) {
    const dayStr = current.format('YYYY-MM-DD');

    const workPackagesStarting = workPackages.filter(
      (wp) => wp.startDate && moment(wp.startDate).isSame(current, 'day')
    );

    const workPackagesEnding = workPackages.filter(
      (wp) => wp.endDate && moment(wp.endDate).isSame(current, 'day')
    );

    days.push({
      date: current.clone(),
      hasWPStart: workPackagesStarting.length > 0,
      hasWPEnd: workPackagesEnding.length > 0,
      workPackagesStarting,
      workPackagesEnding,
    });

    current.add(1, 'day');
  }

  if (days.length < 30) {
    const additionalDays = 30 - days.length;
    const startDate = moment().subtract(3, 'days').startOf('day');
    for (let i = 0; i < additionalDays; i++) {
      const lastDay =
        days.length > 0
          ? days[days.length - 1].date.clone().add(1, 'day')
          : startDate;
      days.push({
        date: lastDay,
        hasWPStart: false,
        hasWPEnd: false,
        workPackagesStarting: [],
        workPackagesEnding: [],
      });
    }
  }

  return days;
}
